// Weekly liability upkeep — called at SettleWeek for every owned liability.
// D5: applied at settle, not pro-rated daily.

import type { GameState } from '../state/types.js';
import { applyTxn } from '../ledger/append.js';

export function settleLiabilityUpkeep(state: GameState): GameState {
  let s = state;
  for (const lia of state.liabilities) {
    if (lia.weeklyUpkeep <= 0) continue;
    s = applyTxn(s, {
      type: 'liability_upkeep',
      amount: -lia.weeklyUpkeep,
      category: 'expense',
      note: `Upkeep — ${lia.defId}`,
    });
  }
  return {
    ...s,
    liabilities: s.liabilities.map((l) => ({ ...l, weeksOwned: l.weeksOwned + 1 })),
  };
}
